import { useState, useEffect } from "react"
import { mapVehicleType } from "../../../state/selectors/vehicleType"
import { AppState } from "../../../state/store"
import { getValuationRequest } from "../valuation/request"
import { getValuationLimit } from "./request"
import { getLeadWithValuationRequest } from "../leadWithValuation/request"
import { checkPath } from '../../../utils/validation-utils'
import { getVehicleDetails, mapCondition } from "../valuation/hook"

export type GetValuationData = {
  email: string
  history: {
    push: Function
    location: {
      search: string
    }
  }
}

export type CustomerData = {
  FirstName: string
  LastName: string
  Email: string
  Mobile: string
  Postcode: string
}

export interface DealershipData {
  DealershipName: string
  DealershipGuid: string
}

export type VehicleBasic = {
  vehicleDetails: object
}
  const CHUSEDCARBUYERGUID = '5fecefb1-3cc1-448b-a168-cdee136cb238'
  const CHUSEDCARBUYER = 'Hurst Car Buyer'

export const useGetValuationLimit = (
  addValuationLimit: Function,
  addVehicleValuation: Function,
  handleError: (error: Error) => any
) => {
  const [requestData, setRequestData] = useState<GetValuationData | null>(null)
  const [vehicleData, setVehicleData] = useState<any | null>(null)
  const [vehicleBasic, setVehicleBasic] = useState<VehicleBasic>()
  const [customerData, setCustomerData] = useState<CustomerData | null>()
  const [dealershipData, setDealershipData] = useState<DealershipData | null>(
    null
  )
  const [vehicleDataForLead, setVehicleDataForLead] = useState<any | null>(null)
  const [group, setGroup] = useState<number | null>(null)


  useEffect(() => {
    if (requestData) {
      const { email }: { email: string } = requestData
      const search = requestData.history.location.search

      getValuationLimit({ email: email })
        .then((data: any) => {
          if (data) {
            if (
              group &&
              vehicleData &&
              vehicleBasic &&
              vehicleDataForLead &&
              customerData &&
              dealershipData
            ) {
              requestData.history.push(`/valuation-given${checkPath(search)}`)
              addValuationLimit(data)
              getValuationRequest(vehicleData, group).then((data) => {
                addVehicleValuation(data?.data)
                if (group === 2)
                {
                  dealershipData.DealershipGuid = CHUSEDCARBUYERGUID 
                  dealershipData.DealershipName = CHUSEDCARBUYER
                  
                  const newVehicleData = {
                    ...vehicleDataForLead,
                    HpiBasicLookup: vehicleData,
                  }
                  getLeadWithValuationRequest(
                    data?.data,
                    customerData,
                    newVehicleData,
                    dealershipData
                  )
                }
              })
            }
          } else {
            requestData.history.push(`/valuations-exceeded${checkPath(search)}`)
          }
        })
        .catch(handleError)
    }
    // eslint-disable-next-line
  }, [
    requestData,
    vehicleData,
    customerData,
    vehicleDataForLead,
    dealershipData,
  ])

  return (
    {
      vehicleDetails,
      vehicleCondition,
      mileage,
      groupId,
      registration,
      appointmentDetails: { dealership },
      dealershipGuid,
      contactDetails: { firstName, lastName, email, contactNumber, postcode },
    }: AppState,
    history: any
  ) => {
    const convertedMileageToString = mileage.toString().split(",").join("")

    const { capId, capCode, dateRegistered, vehicleType } =
      getVehicleDetails(vehicleDetails)

    setVehicleData({
      capId: parseInt(capId),
      capCode: capCode,
      mileage: parseInt(convertedMileageToString),
      dateRegistered: dateRegistered,
      condition: mapCondition(vehicleCondition),
      vehicleType: mapVehicleType(vehicleType),
      history,
    })
    setGroup(groupId)
    setVehicleDataForLead({
      Registration: registration,
      Mileage: parseInt(convertedMileageToString),
      Condition: mapCondition(vehicleCondition),
    })
    setVehicleBasic({ vehicleDetails })
    setRequestData({
      email: email,
      history,
    })
    setCustomerData({
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Mobile: contactNumber,
      Postcode: postcode,
    })
    setDealershipData({
      DealershipName: dealership,
      DealershipGuid: dealershipGuid,
    })
  }
}
